import logo from '@assets/logo.webp'

interface LogoProps {
  className?: string
}

export default function Logo({ className }: LogoProps) {
  return (
    <img width={150} height={100} src={logo} alt="Logo" className={className} />
  )
}
